<template>

  <div class="form-group" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <div class="input-group">
      <div class="date-wrapper" @click="_dateIconClick">
        <div class="date-picker-overlay"></div>
        <span class="input-group-addon">
            <i class="icon wb-calendar" aria-hidden="true"></i>
          </span>
        <input
          v-model="value"
          ref="element"
          type="text"
          autocomplete="off"
          readonly="readonly"
          class="form-control input-date"
        >
      </div>
    </div>
    <div class="clearfix"></div>
    <div v-if="this.buttonsDef.length" class="col-sm-4 pl-0 form-element-button-wrapper">
      <form-action-button
        :def="def"
        :buttonsDef="buttonsDef"
        :updateDataRequest="updateDataRequest"
        :formDataChanged="formDataChanged"/>
    </div>
  </div>

</template>

<script>
import DatetimeParser           from '../../../model/parser/datetime-parser'
import CalendarTranslator       from '../../../model/translator/CalendarTranslator'
import IconsRender              from '../../templates/widgets/icons-render'
import FormActionButton         from '../../widgets/forms/form-action-button'
import FormElementButtonsHelper from '../../../model/helper/forms/form-element-buttons-helper'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'date-picker',
  components: {
    FormActionButton,
    IconsRender
  },
  props:      {
    def:               {
      type:    Object,
      default: () => {
        return {}
      }
    },
    updateDataRequest: {
      type:    Function,
      default: null
    },
    formDataChanged:   {
      type:    Function,
      default: null
    },
    element:           {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },

  data () {
    return {
      value:      '',
      stateValue: DatetimeParser.createDate(),
      buttonsDef: [],
      render:     true
    }
  },

  created () {
    let tr = (key) => {
      return this.$translate.text(key)
    }

    let translator = new CalendarTranslator(this.$translate)

    $.fn.datepicker.dates['own'] =
      {
        days:        translator.getDays(),
        daysShort:   translator.getShortDays(),
        daysMin:     translator.getMinDays(),
        months:      translator.getMonths(),
        monthsShort: translator.getShortMonths(),
        today:       tr('date_today'),
        clear:       tr('date_clear'),
        titleFormat: 'MM yyyy'
      }
  },

  mounted () {
    this.buttonsDef = FormElementButtonsHelper.getButtonsDef(this.element)

    if (this.element.readonly) {
      return
    }

    let dateElement = $(this.$refs.element)

    // stejne jako DateTimePicker!!!
    // @TODO: refaktor!!
    dateElement
      .datepicker({
        format:         'd.m.yyyy',
        todayHighlight: true,
        orientation:    'left auto',
        language:       'own',
        weekStart:      1,
        autoClose:      true,
        todayBtn:       true,
        clearBtn:       true
      })
      .on('changeDate', (event) => {
        if (!event.date) {
          this.stateValue = null
          this.value      = null

          this._changeValue()

          return
        }

        if (event.date && !this.stateValue) {
          this.stateValue = DatetimeParser.createDate()
        }

        this.stateValue = event.date
        this.value      = DatetimeParser.parseLocaleDate(this.stateValue.toLocaleString())

        this._changeValue()

        dateElement.datepicker('hide')
      })
  },

  methods: {

    /**
     *
     * @private
     */
    _changeValue () {
      this.$emit('changeValue', { element: this.element, value: this._prepareValue() })
      this.$emit('blur', { element: this.element, value: this._prepareValue() })
    },

    /**
     *
     * @return {string|null}
     * @private
     */
    _prepareValue () {
      if (!this.stateValue) {
        return null
      }

      let dateTime = this.stateValue.toLocaleString()

      return DatetimeParser.parseLocaleDate(dateTime) + ' ' + DatetimeParser.parseLocaleTime(dateTime)
    },

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      if (!value) {
        this.value = null
        return
      }

      let splitValue = value.split('T'),
          date       = splitValue[0].split('-'),
          year       = date[0],
          month      = parseInt(date[1]),
          day        = parseInt(date[2])

      this.value      = DatetimeParser.parseDate(splitValue[0])
      this.stateValue = DatetimeParser.createDate(year, month, day)

      if (this.element.readonly) {
        return
      }

      $(this.$refs.element).datepicker('update', this.stateValue)
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _dateIconClick () {
      if (this.element.readonly) {
        return
      }

      $(this.$refs.element).datepicker('show')
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }
  }

}
</script>

<style>
.datepicker-dropdown {
  z-index: 99999 !important;
}
</style>
